// const rivyoInterval = setInterval(function () {

//     const widget = document.querySelector('.wc_review_widget');
//     const actions = document.querySelector('.wc_rivyo_actions');
//     const summaryAction = document.querySelector('.wc_review_summary_action ul');

//     if (widget && actions && summaryAction) {

//         // Default hide
//         widget.style.display = "none";
//         actions.style.display = "none";

//         // Remove click events from head so it does nothing
//         const head = document.querySelector('.wc_review_head');
//         if (head) {
//             head.replaceWith(head.cloneNode(true));
//         }

//         // Create new button if not already added
//         if (!document.querySelector('.see-all-reviews-btn')) {

//             const newLi = document.createElement('li');
//             const newBtn = document.createElement('button');

//             newBtn.type = "button";
//             newBtn.className = "see-all-reviews-btn";
//             newBtn.style.cssText = `
//                 cursor: pointer;
//                 display: flex;
//                 gap: 8px;
//                 align-items: center;
//                  color: #fff;
//                 background-color: #000;
//                 border: 3px solid #000;
//                 padding: 14px 20px;
//                 cursor: pointer;
//                 line-height: 20px;
//                 justify-content: center;
//             `;

//             // Default text + plus icon
//             newBtn.innerHTML = `See All Reviews <span class="toggle-icon">+</span>`;

//             newLi.appendChild(newBtn);
//             summaryAction.appendChild(newLi);

//             // Toggle reviews & icon
//             newBtn.addEventListener("click", function () {
//                 const hidden = widget.style.display === "none";
//                 const icon = newBtn.querySelector('.toggle-icon');

//                 // Toggle show/hide
//                 widget.style.display = hidden ? "block" : "none";
//                 actions.style.display = hidden ? "flex" : "none";

//                 // Toggle icon
//                 icon.textContent = hidden ? "−" : "+";
//             });
//         }

//         clearInterval(rivyoInterval);
//     }

// }, 300);


// Permanent listener – rivyo re-render hone par bhi chalega
setInterval(() => {

    const widget = document.querySelector('.wc_review_widget');
    const actions = document.querySelector('.wc_rivyo_actions');
    const summaryAction = document.querySelector('.wc_review_summary_action ul');

    if (!widget || !actions || !summaryAction) return;

    // Default hide once per re-render
    if (!widget.dataset.hiddenApplied) {
        widget.style.display = "none";
        actions.style.display = "none";
        widget.dataset.hiddenApplied = "true";
    }

    // Remove head click (Rivyo re-add karta hai)
    const head = document.querySelector('.wc_review_head');
    if (head && !head.dataset.cleaned) {
        head.replaceWith(head.cloneNode(true));
        head.dataset.cleaned = "true";
    }

    // Add button if missing (Rivyo re-render hote hi button delete ho jata)
    if (!document.querySelector('.see-all-reviews-btn')) {

        const newLi = document.createElement('li');
        const newBtn = document.createElement('button');

        newBtn.type = "button";
        newBtn.className = "see-all-reviews-btn";

        newBtn.style.cssText = `
            cursor: pointer;
            display: flex;
            gap: 8px;
            align-items: center;
            color: #fff;
            background-color: #000;
            border: 3px solid #000;
            padding: 14px 20px;
            line-height: 20px;
            justify-content: center;
        `;

        newBtn.innerHTML = `See All Reviews <span class="toggle-icon">+</span>`;

        newLi.appendChild(newBtn);
        summaryAction.appendChild(newLi);

        // Toggle logic
        newBtn.addEventListener("click", function () {

            const isHidden = widget.style.display === "none";
            const icon = newBtn.querySelector(".toggle-icon");

            widget.style.display = isHidden ? "block" : "none";
            actions.style.display = isHidden ? "flex" : "none";

            icon.textContent = isHidden ? "−" : "+";
        });
    }

}, 400);


